import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
// import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useSelector } from "react-redux";
import userActions from "./actions";
import useStyles from "./Styles";

export default function ChartSidebarAccordion({hidden=false, group_name, accordion_name, children }) {
  const classes = useStyles();
  const {updateSidebarAccordions} = userActions();
  // const [expanded, setExpanded] = useState(group_name);
  const [expanded, setExpanded] = useState(false);
  const { sidebar_accordions, chart} =
    useSelector((state) => state.technical_view);


  const handleChange = (panel) => (_event) => {
    // console.log("expanded: "+expanded)
    // console.log("newExpanded: "+newExpanded) // newExpanded is the second parameter of handleChange function
    // setExpanded(newExpanded ? panel : false);
    // console.log(expanded);
    setExpanded(()=>!expanded);
    updateSidebarAccordions(panel);
  };

  // ensures accordion defaults as expanded
  const setSidebarAccordion = () => {
    setExpanded(sidebar_accordions[chart].hasOwnProperty(accordion_name)? sidebar_accordions[chart][accordion_name] : true);
  }
  useEffect(setSidebarAccordion, [sidebar_accordions[chart][accordion_name]]);

  return (
    <div>
      <Accordion
        square
        // expanded={expanded === group_name}
        expanded={expanded}
        onChange={handleChange(accordion_name)}
        classes={{ root: classes.accordion }}
        className={classes.expanded}
        hidden={hidden}
      >
        <AccordionSummary
          aria-controls={`${group_name}-pulldown`}
          // expandIcon={<ArrowForwardIosIcon className="icon" />}
          expandIcon={<ExpandMoreIcon />}
          classes={{
            root: classes.accordionSummary,
            expanded: classes.accordionSummaryExpanded,
            content: classes.accordionSummaryContent,
          }}
        >
          <Typography className={classes.groupName}>{group_name}</Typography>
        </AccordionSummary>
        <AccordionDetails classes={{ root: accordion_name === 'availability' ?  classes.accordionDetailsGauge : classes.accordionDetails }}>
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
